/**
* Web Service handler to retrieve and represent a list of OAuth tokens
*
* @class OAuthWS
*/
var OAuthWS = function (parent) {
	var self = this; // Convenience reference so the context of 'this' becomes clearer

	// Predicate this Web Service handler on the Abstract class of a Web
	// Service handler. This establishes core functionality required of
	// these such handlers, which can be overwritten by methods below.
	AbstractWS.apply(this, arguments);

	self.authNameError		= ko.observable( null );
	self.auths				= ko.observableArray( [] );
	self.dataType			= 'json';
	self.endpoint			= ko.observable('/qless/api/v1/employee/oauth2/credentials');
	self.endpoints			= {
								'check': '/qless/api/v1/employee/oauth2/credentialByName?name={0}',
								'default': '/qless/api/v1/employee/oauth2/credentials',
								'disable': '/qless/api/v1/employee/oauth2/credentials/{0}/disable',
								'enable': '/qless/api/v1/employee/oauth2/credentials/{0}/enable',
								'revoke': '/qless/api/v1/employee/oauth2/credentials/{0}/revoke'
								};
	self.mode				= ko.observable('default');
	self.name				= 'OAuthWS';			// Convenience name for debugging
	self.newConnectionName	= ko.observable(null);
	self.oauthAPI			= {
								'1': '/qless/api/v1/employee/oauth2/add?provider=GoogleOAuth2&name={0}',
								'2': null
							};
	// This observable tracks which oauth the user selects in the UI to create a binding with
	self.oAuthSel			= ko.observable( null );



	/**
	* API Endpoint
	*
	* @method serviceURL
	* @return {String}
	*/
	self.serviceURL	= ko.computed( function () {
		return self.endpoint();
	});


	/**
	* Returns a CSS class to the UI
	*
	* @method authIcon
	* @param {Object} data
	* @return {String}
	*/
	self.authIcon = function ( data ) {
		return 'authicon-' + ( ( data.providerId == 1 ) ? 'google' : 'outlook' );
	};


	/**
	* Sends the user to the selected authorization workflow
	*
	* @method beginAuthWorkflow
	* @param {Object} data
	* @param {MouseEvent} evt
	* @return none
	*/
	self.beginAuthWorkflow = function ( data, evt ) {
		var el = evt.target,
			authName = self.newConnectionName().replace(' ', '_'),
			redirect = null;

		if ( $( el ).hasClass('oauth-btn') && !self.checkButtonDisabled() ) {
			var providerId = evt.target.getAttribute('data-providerid');

			// Google Calendar
			if ( providerId == 1 ) {
				document.location.href = self.oauthAPI[ providerId ].replace( '{0}', authName );
			}
			// Outlook Temporary ICS download
			else if ( providerId == 2 ) {
				self.oAuthSel( true );
				self.parent.icalShowNewAuth( false );
			}
		}
	};


	/**
	* Determines if the UI element is enabled or greyed out
	*
	* @method checkButtonDisabled
	* @return {Boolean}
	*/
	self.checkButtonDisabled = ko.computed( function () {
		var name = self.newConnectionName();

		if ( !name || name.length < 3 || self.authNameError() !== false ) {
			return true;
		}

		return false;
	});


	/**
	* Determines if the user has already created a named authorization with the input name
	*
	* @method checkNamedOAuth
	* @return none
	*/
	self.checkNamedOAuth = function () {
		// If there are no existing auths for this user, then there is no conflict
		if ( self.auths().length == 0 ) {
			self.authNameError( false );
		}
		// Otherwise check the service for a name conflict
		else if ( self.newConnectionName() ) {
			self.endpoint( self.endpoints['check'].replace( '{0}', self.newConnectionName().replace(' ', '_') ) );
			self.mode('check');
			self.doRequest();
		}
	};


	/**
	* Turns off the authorization
	*
	* @method disable
	* @param {Number} id
	* @return none
	*/
	self.disable = function ( id ) {
		self.endpoint( self.endpoints['disable'].replace( '{0}', id ) );
		self.mode('disable');
		self.doRequest();
	};


	/**
	* Turns on the authorization
	*
	* @method enable
	* @param {Number} id
	* @return none
	*/
	self.enable = function ( id ) {
		self.endpoint( self.endpoints['enable'].replace( '{0}', id ) );
		self.mode('enable');
		self.doRequest();
	};


	/**
	* Finds an auth with a matching ID
	*
	* @method getAuthById
	* @param {Number} id
	* @return {OAuthModel | Null}
	*/
	self.getAuthById = function ( id ) {
		return self.auths().find( function ( auth ) {
			return auth.id == id;
		});
	};


	/**
	* Finds a named authorization
	*
	* @method getAuthByName
	* @param {String} sName
	* @return {Object | Null}
	*/
	self.getAuthByName = function ( sName ) {
		return self.auths().find( function ( auth ) {
			return auth.name == sName;
		});
	};


	/**
	* This method pushed the returned authorizations to the observable collection 'auths'
	*
	* @method processData
	* @param {JSON} data JSON data returned from the service
	* @return {OAuthWS} Returns the object as chainable, for best practice
	*/
	self.processData = function ( data ) {
		// Call the superclass method to perform any core actions
		AbstractWS.prototype.processData.call(self, data);

		switch ( self.mode() ) {
			case 'default':
				// Remove any pre-existing authorizations from the collection
				self.setAuthorizations( data );
				break;

			case 'check':
				self.authNameError( ( data.credentials.length > 0 ) );
				break;

			case 'disable':
				self.setAuthorizations( data );
				break;

			case 'enable':
				self.setAuthorizations( data );
				break;

			case 'revoke':
				self.setAuthorizations( data );
				break;

			default:
				console.log( data );
				break;
		}

		// Return self (OAuthWS) to be chainable, for best practice
		return self;
	};


	/**
	* Returns this object to it's default state
	*
	* @method
	* @param
	* @return
	*/
	self.reset = function () {
		self.authNameError( null );
		self.auths.removeAll();
		self.endpoint( self.endpoints['default']);
		self.mode('default');
		self.newConnectionName	= ko.observable(null);
	};


	/**
	* Terminates an oauth connection
	*
	* @method revoke
	* @param {OAuthModel} data
	* @param {MouseEvent} evt
	* @return none
	*/
	self.revoke = function ( data, evt ) {
		var id = data.id;

		self.endpoint( self.endpoints['revoke'].replace( '{0}', id ) );
		self.mode('revoke');
		self.doRequest();
	};


	/**
	* Processes through a JSON object and sets the authorizations accordingly
	*
	* @method setAuthorizations
	* @param {JSON} data
	* @return none
	*/
	self.setAuthorizations = function ( data ) {
		var aAuths = [];

		self.auths.removeAll();

		data.credentials.forEach( function ( cred ) {
			aAuths.push( new OAuthModel( cred ) );
		});

		self.auths( aAuths );

		if ( aAuths.length > 0 ) {
			qcal.icalShowNewAuth( false );
		}

		// If there is only one auth, make sure it is selected by default
		if ( aAuths.length == 1 && !self.parent.oAuthHasAssociation( aAuths[0] ) ) {
			self.oAuthSel( aAuths[0].id );
		}
	};


	/**
	* Handles click events in the UI to select the OAuth to create a binding
	*
	* @method setOAuthSel
	* @param {OAuthModel} data
	* @param {MouseEvent} evt
	* @return none
	*/
	self.setOAuthSel = function ( data, evt ) {
		if ( evt.target.nodeName.toLowerCase() == 'li' ) {
			if ( data.id == self.oAuthSel() ) {
				if ( self.auths().length != 1 ) {
					self.oAuthSel( null );
				}
			}
			else {
				self.oAuthSel( data.id );
			}
		}
	};


	/**
	* Enables/Disables an Oauth status
	*
	* @method toggleStatus
	* @param {OAuthModel} data
	* @param {MouseEvent} evt
	* @return none
	*/
	self.toggleStatus = function ( data, evt ) {
		if ( data.status().toLowerCase() == 'active' ) {
			self.disable( data.id );
		}
		else {
			self.enable( data.id );
		}
	};


	/**
	* Watch for changes to the new connection name and submit a check if
	* it's 3 or more characters
	*
	* @method newConnectionName.subscribe
	* @param {Number}
	* @return none
	*/
	self.newConnectionName.subscribe( function ( newVal ) {
		if ( newVal.length >= 3 ) {
			self.checkNamedOAuth();
		}
	});


	return self;
};

OAuthWS.prototype = AbstractWS.prototype;
OAuthWS.prototype.constructor = OAuthWS;
